import { DialogContent, Typography, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ErrorTitle from './ErrorTitle';

const NetworkStreamError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("We can't perform a fair network test")} />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              "We couldn't find your camera nor microphone. This means that your video and audio won't be heard nor shown to other participants in the meeting. This also means we cant perform a realistic network test before the meeting."
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

const NetworkStreamingError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle
        title={t("You're not able to send or receive video and audio")}
      />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              'This is required to make meetings work. The reason for this might be your firewall blocking traffic.'
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

const NetworkTokenError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("You're not able to connect to the server")} />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              'This is required to make meetings work. The reason for this might be your firewall blocking traffic.'
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

const NetworkSocketError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t("You're not able to connect to the websocket")} />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              'This is required to make meetings work. The reason for this might be your firewall blocking websocket connections.'
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

const NetworkUnexpectedError = () => {
  const { t } = useTranslation();
  return (
    <>
      <ErrorTitle title={t('Unexpected error')} />
      <DialogContent>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              'Please retry the test. If the issue persists, please contact support.'
            )}
          </Typography>
        </Grid>
      </DialogContent>
    </>
  );
};

export {
  NetworkStreamError,
  NetworkStreamingError,
  NetworkTokenError,
  NetworkSocketError,
  NetworkUnexpectedError,
};
